export default {
    WARPED_TO: 'Te has teletransportado a {{name}}.',

    CANNOT_WARP_ACHIEVEMENT:
        'Este teletransportador requiere que se complete un logro antes de su uso.',
    CANNOT_WARP_QUEST: 'Debes completar {{questName}} para viajar a {{name}}.',
    CANNOT_WARP_LEVEL: 'Debes tener al menos el nivel {{level}} para teletransportarte aquí.',
    CANNOT_WARP_JAIL: 'No puedes teletransportarte, estás encarcelado por otro {{time}}.',
    CANNOT_WARP_TUTORIAL: 'Debes terminar el tutorial antes de teletransportarte.',
    CANNOT_WARP_COMBAT:
        'Debes esperar 10 segundos después de terminar el combate para teletransportarte.',
    CANNOT_WARP_COOLDOWN: 'Debes esperar otro {{time}} para teletransportarte.'
} as const;
